import './_diag-tab.sass';

import $ from 'jquery';

import Class from '../legacy-class';

import {DeviceTab, DeviceTabContents} from '../../graphs/components/device';
import '../../../../mui/scroll';

import loading_gif_url from '../../../../img/loading.gif';

var DiagTabContent = Class(DeviceTabContents, {
    init: function (ui, options) {
        this._ui = ui;

        this._device = options.device;

        this._element = $(
            '<div class="ui-diag-tab">' +
                '<div class="ui-diag-tab-column-1">' +
                '<div class="ui-diag-tab-activity">' +
                '<div class="ui-diag-tab-activity-indicator"></div>' +
                '<h2>ДИАГНОСТИКА АКТИВНА</h2>' +
                '</div>' +
                '<h2>ОШИБКИ ЭБУ</h2>' +
                '<div class="ui-diag-tab-error-list-container">' +
                '<div class="ui-diag-tab-error-list"></div>' +
                '<div class="ui-diag-tab-busy-indicator">' +
                '<img/>' +
                '</div>' +
                '</div>' +
                '<button>сбросить ошибки</button>' +
                '<div class="ui-diag-tab-clear-response">' +
                '<div></div>' +
                '<span></span>' +
                '</div>' +
                '</div>' +
                '<div class="ui-diag-tab-column-2">' +
                '<h2>АВТОМАТИЧЕСКИЕ УВЕДОМЛЕНИЯ: <span role="notifications"></span></h2>' +
                '<div class="ui-diag-tab-hint" role="notifications-off">Если вы&nbsp;хотите получать автоматические уведомления о&nbsp;возникновении ошибок блока управления двигателем, задайте <a href="#" class="ui-diag-tab-open-notifications">параметры оповещения</a> в&nbsp;настройках устройства.</div>' +
                '<div class="ui-diag-tab-hint" role="notifications-on">Изменить параметры уведомлений можно в&nbsp;<a href="#" class="ui-diag-tab-open-notifications">настройках устройства</a>.</div>' +
                '</div>' +
                '</div>'
        )
            .find('.no-click')
            .click(false)
            .end()
            .find('button')
            .toggle(this._device.has_capability('has_ecu_errors_reset'))
            .click(this._onClearClick.bind(this))
            .end()
            .find('img')
            .attr('src', loading_gif_url)
            .end()
            .find('.ui-diag-tab-open-notifications')
            .click(
                function () {
                    this._ui.open_device_settings_dialog('notifications');
                    return false;
                }.bind(this)
            )
            .end()
            .find('.ui-diag-tab-column-2')
            .toggle(this._device.has_capability('has_notifications'))
            .end();

        this._errorList = this._element.find('.ui-diag-tab-error-list').scrollable();

        this._device.bind({
            current_ecu_errors: this._onErrorsChanged.bind(this),
            saved_ecu_errors: this._onErrorsChanged.bind(this),
            notifications: this._onNotificationsChanged.bind(this),

            ecu_diagnostics_active: this._onDiagnosticsActiveChanged.bind(this),
        });
        this._onErrorsChanged();
        this._onNotificationsChanged();
        this._onDiagnosticsActiveChanged();

        this._ui.store.subscribe(() => {
            const selected_id = this._ui.store.getState().devices.selected_id;
            const device = this._ui.store
                .getState()
                .devices.items.find((device) => device.id === selected_id);

            this._onErrorsChanged_redux(device);
            this._onNotificationsChanged_redux(device);
            this._onDiagnosticsActiveChanged_redux(device);
        });
    },

    _createErrors: function (errors) {
        var result = $();

        for (var code in errors)
            if (errors.hasOwnProperty(code)) {
                var item = $('<div>', {class: 'ui-diag-tab-ecu-error'}).append(
                    $('<h3>').text('ОШИБКА ' + errors[code].display_code)
                );

                if (errors[code].description)
                    result = result.add(
                        item.append(
                            $('<div>', {
                                class: 'ui-diag-tab-ecu-error-description',
                            }).text(errors[code].description)
                        )
                    );

                result.add(item);
            }

        return result;
    },

    _onErrorsChanged: function () {
        var errorList = this._element
            .find('.ui-diag-tab-error-list')
            .scrollable('content')
            .empty();

        var current = this._createErrors(this._device.current_ecu_errors());
        var saved = this._createErrors(this._device.saved_ecu_errors());

        if (current.length > 0)
            errorList
                .append('<div class="ui-diag-tab-error-caption">Текущие ошибки</div>')
                .append(current);
        if (saved.length > 0)
            errorList
                .append(
                    '<div class="ui-diag-tab-error-caption">Сохранённые ошибки</div>'
                )
                .append(saved);

        if (current.length == 0 && saved.length == 0)
            errorList.append('<div class="ui-diag-tab-error-caption">Ошибок нет</div>');

        errorList.find('.ui-diag-tab-ecu-error').filter(':odd').addClass('odd');

        this._element.find('.ui-diag-tab-error-list').scrollable('handleResize');
    },

    _onErrorsChanged_redux(device) {
        var errorList = this._element
            .find('.ui-diag-tab-error-list')
            .scrollable('content')
            .empty();

        var current = this._createErrors(device.current_ecu_errors);
        var saved = this._createErrors(device.saved_ecu_errors);

        if (current.length > 0)
            errorList
                .append('<div class="ui-diag-tab-error-caption">Текущие ошибки</div>')
                .append(current);
        if (saved.length > 0)
            errorList
                .append(
                    '<div class="ui-diag-tab-error-caption">Сохранённые ошибки</div>'
                )
                .append(saved);

        if (current.length == 0 && saved.length == 0)
            errorList.append('<div class="ui-diag-tab-error-caption">Ошибок нет</div>');

        errorList.find('.ui-diag-tab-ecu-error').filter(':odd').addClass('odd');

        this._element.find('.ui-diag-tab-error-list').scrollable('handleResize');
    },

    _onClearClick: function () {
        this._element.find('.ui-diag-tab-busy-indicator').addClass('visible');
        this._element.find('button').prop('disabled', true);

        this._device.clearECUErrors(
            function (response) {
                var ui_response = this._element.find('.ui-diag-tab-clear-response');
                ui_response
                    .attr('role', response.ok ? 'success' : 'fail')
                    .find('span')
                    .text(response.error)
                    .end()
                    .addClass('visible');

                this._element
                    .find('.ui-diag-tab-busy-indicator')
                    .removeClass('visible');
                this._element.find('button').prop('disabled', false);

                if (this._responseHideInterval)
                    clearInterval(this._responseHideInterval);

                this._responseHideInterval = setInterval(function () {
                    ui_response.removeClass('visible');
                }, 5000);
            }.bind(this)
        );
    },

    _onNotificationsChanged: function () {
        var val = this._device.notifications();

        var configured =
            val && val.info && val.info.ecu_error != 'off' && val.info.numbers != '';

        this._element
            .find('[role="notifications"]')
            .text(configured ? 'ВКЛЮЧЕНЫ' : 'ВЫКЛЮЧЕНЫ');

        this._element
            .find('[role="notifications-off"]')
            .toggleClass('visible', !configured);
        this._element
            .find('[role="notifications-on"]')
            .toggleClass('visible', configured);
    },

    _onNotificationsChanged_redux(device) {
        var val = device.notifications;

        var configured =
            val && val.info && val.info.ecu_error != 'off' && val.info.numbers != '';

        this._element
            .find('[role="notifications"]')
            .text(configured ? 'ВКЛЮЧЕНЫ' : 'ВЫКЛЮЧЕНЫ');

        this._element
            .find('[role="notifications-off"]')
            .toggleClass('visible', !configured);
        this._element
            .find('[role="notifications-on"]')
            .toggleClass('visible', configured);
    },

    _onDiagnosticsActiveChanged: function () {
        this._element
            .find('.ui-diag-tab-activity')
            .toggleClass('visible', this._device.ecu_diagnostics_active() != null)
            .toggleClass('active', !!this._device.ecu_diagnostics_active())
            .find('h2')
            .text(this._device.ecu_diagnostics_active() ? 'НА СВЯЗИ' : 'НЕТ СВЯЗИ');
    },

    _onDiagnosticsActiveChanged_redux(device) {
        this._element
            .find('.ui-diag-tab-activity')
            .toggleClass('visible', device.ecu_diagnostics_active != null)
            .toggleClass('active', !!device.ecu_diagnostics_active)
            .find('h2')
            .text(device.ecu_diagnostics_active ? 'НА СВЯЗИ' : 'НЕТ СВЯЗИ');
    },
});

var DiagTab = Class(DeviceTab, {
    init: function (ui) {
        'use strict';
        DiagTab.superclass.init.call(this, ui, {
            contentClass: DiagTabContent,
            divclass: '',
            tabtitle: 'диагностика',
            tabicon: 'ui-icon-tab-diagnostics',
            role: 'diagnostics',
            should_appear_depends_on: [
                'capabilities',
                'ecu_diagnostics_enabled',
                'access',
            ],
            should_appear: this.should_appear,
        });
    },

    should_appear: function (device) {
        return (
            device &&
            device.has_access('view_state') &&
            device.has_capability('has_car_diagnostics') &&
            device.ecu_diagnostics_enabled()
        );
    },
});

DiagTab.should_appear_depends_on = [
    'capabilities',
    'ecu_diagnostics_enabled',
    'access',
];
DiagTab.should_appear = DiagTab.prototype.should_appear;

export default DiagTab;
